import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import exploreService from '@services/exploreService';
export default {
  name: 'jiemeitaoList',
  components: {},
  props: {},
  data: function data() {
    return {
      ExploreAPIService: null,
      pageSize: 32,
      // 1页加载个数
      pageIndex: 1,
      rdList: [],
      APIExplore: null
    };
  },
  watch: {},
  methods: {
    gotoLink: function gotoLink(url) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var otherWindow;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              otherWindow = window.open(url);
              if (otherWindow) {
                otherWindow.opener = null;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.bannerToList();
            case 2:
              _this.rdList = _context2.sent;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    bannerToList: function bannerToList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this2.ExploreAPIService.bannerToList({
                location_id: 103,
                countryCode: 'TW'
              });
            case 2:
              data = _context3.sent;
              return _context3.abrupt("return", data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    util.loadingFunc({
      time: 1000
    });
    this.ExploreAPIService = exploreService.createApi();
  },
  mounted: function mounted() {
    this.getData();
  }
};